{
  "alpha": "Alfa",
  "blue": "Azul",
  "brightness": "Luminosidade",
  "green": "Verde",
  "hue": "Tonalidade",
  "lightness": "Claridade",
  "red": "Vermelho",
  "saturation": "Saturação"
}
